import { countries } from './countries';
import { CountryCodes, ISO3CountryCodes } from './types';

/**
 * Get default country from countries list.
 */

export const findCountryByCode = (code: CountryCodes | ISO3CountryCodes) =>
  countries.find(
    ({ countryCode, ISO3CountryCodes }) => countryCode === code || ISO3CountryCodes === code
  );

/**
 * Find country by provided phone number (E.164 formatted).
 */
export const findCountryByPhone = (phone: string) => {
  let result;

  // iterate over countries
  for (let i = 0; i < countries.length; i += 1) {
    const { dialCode, areaCodes, priority } = countries[i];

    // check for suitable dialCode, otherwise jump to the next iteration
    if (phone.startsWith(dialCode)) {
      if (areaCodes) {
        // for the countries with same dialCode, try to find by areaCode
        for (let j = 0; j < areaCodes.length; j += 1) {
          if (phone.startsWith(`${dialCode}${areaCodes[j]}`)) {
            return countries[i];
          }
        }
      } else if (!result || result.priority > priority) {
        // otherwise, set current country as main
        // if the country has not been selected or has a highest prioriy
        result = countries[i];
      }
    }
  }

  return result;
};
